import { StrictMode } from 'react'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import '../styles/globals.css'
import '@integration-app/react/styles.css'
import '../styles/overrides.css'

import RootRoutes from './_routes'
import { ENV_CONFIG } from '../config/env'

if (ENV_CONFIG.ENABLE_TRACKING) {
  Sentry.init({
    dsn: 'https://71439af05abc42d984c6d8ead38de3a8@o956397.ingest.sentry.io/5905799',
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootRoutes />
  </StrictMode>,
)
